<template>
  <div>
    <vue-good-table
      :rows="recipients"
      :columns="tableColumns"
      styleClass="vgt-table"
      :sort-options="{
        enabled: false,
      }"
    >
      <template v-slot:table-row="{ row, column }">
        <span v-if="column.field == 'name'">
          {{ row.user.name }}
        </span>
        <span v-if="column.field == 'email'">
          {{ row.user.email }}
        </span>
        <span v-if="column.field == 'status'">
          <span
            v-if="status(row) === 'Open'"
            class="text-success"
          >Opened</span>
          <span v-else>
            {{ status(row) }}
          </span>

        </span>
      </template>
    </vue-good-table>
    <pagination
      :data="pagination"
      @change-page="changePage"
    />
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

import Pagination from '@/components/Pagination'
import gateway from '@/gateway'
import {capitalize} from '@/helpers'

export default {
  components: {
    VueGoodTable,
    Pagination,
  },

  props: {
    newsletter: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      statusCache: {},
      recipients: [],
      pagination: null,
      page: 1,
      tableColumns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
    }
  },

  mounted () {
    this.getRecipients()
  },

  methods: {

    async getRecipients () {
      const response = await gateway.get(`/newsletters/recipients/${this.newsletter._id}?page=${this.page}`)
      this.recipients = response.data.data
      this.pagination = response.data.meta
    },

    changePage (page) {
      this.page = page
      this.getRecipients()
    },

    status (row) {
      if (row.analytics.length === 0 && row.notification.id === null) {
        return 'Queued'
      }
      if (row.analytics.length === 0) {
        return 'Pending'
      }

      if (this.statusCache[row.id]) {
        return this.statusCache[row.id]
      }

      const analytics = [...row.analytics]
      analytics.sort((a, b) => {
        return a.timestamp > b.timestamp ? -1 : 1
      })

      this.statusCache[row.id] = capitalize(analytics[0].event)

      return this.statusCache[row.id]
    },
  }
}
</script>
